import switchPanes from './switchPanes';

/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const moveMarkerPane = (gmap: any) => {
  const gm = gmap.__gm;
  let i = 0;
  const interval = setInterval(() => {
    const panesSuccess = switchPanes(gm);

    i += 1;
    if (!panesSuccess && i < 10) return;

    clearInterval(interval);
  }, 200);
};
export default moveMarkerPane;
